import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingCandidate'), ...new Mutations('jobListingCandidates') };
